/* Reuse the real Shopify product form, inventory, validation and cart handling. */
if (!customElements.get('atiems-fp-sticky')) {
  customElements.define('atiems-fp-sticky', class extends HTMLElement {
    connectedCallback() {
      this.qtyInput = this.querySelector('[data-fp-qty-input]');
      this.addButton = this.querySelector('[data-fp-add]');
      this.price = this.querySelector('[data-fp-price]');
      this.addLabel = this.addButton?.textContent.trim() || 'Į krepšelį';
      this.onClick = event => {
        if (event.target.closest('[data-fp-add]')) this.submit();
        const step = event.target.closest('[data-fp-qty]');
        if (!step || !this.qtyInput) return;
        const increment = Number(this.qtyInput.step) || 1;
        const min = Number(this.qtyInput.min) || 1;
        const max = this.qtyInput.max === '' ? Infinity : Number(this.qtyInput.max);
        this.qtyInput.value = Math.min(max, Math.max(min,
          (Number(this.qtyInput.value) || min) + Number(step.dataset.fpQty) * increment));
      };
      this.onVariant = event => {
        if (event.detail?.formId && event.detail.formId !== this.form?.getAttribute('id')) return;
        requestAnimationFrame(() => this.refresh());
      };
      this.onState = () => this.updateVisibility();
      this.onQuantity = event => {
        if (event.target === this.mainQuantity && this.qtyInput) this.qtyInput.value = this.mainQuantity.value;
      };
      this.onResize = () => this.updateVisibility();
      this.addEventListener('click', this.onClick);
      document.addEventListener('variant:change', this.onVariant);
      document.addEventListener('dialog:after-show', this.onState);
      document.addEventListener('dialog:after-hide', this.onState);
      document.addEventListener('change', this.onQuantity);
      window.addEventListener('resize', this.onResize, { passive: true });
      const main = document.querySelector('.shopify-section--main-product');
      this.mainObserver = new MutationObserver(() => this.refresh());
      if (main) this.mainObserver.observe(main, { childList: true, subtree: true,
        attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
      this.drawerObserver = new MutationObserver(this.onState);
      document.querySelectorAll('#cart-drawer, #sidebar-menu, #shopify-pc__banner, .shopify-pc__banner__dialog')
        .forEach(element => this.drawerObserver.observe(element, { attributes: true,
          attributeFilter: ['open', 'hidden', 'class', 'style'] }));
      this.refresh();
    }
    refresh() {
      const form = document.querySelector('.shopify-section--main-product form[id^="product-form-main-"][action*="/cart/add"]');
      const button = form?.querySelector('buy-buttons button[type="submit"]');
      this.form = form;
      if (button !== this.mainButton) {
        this.mainButton = button;
        this.buttonObserver?.disconnect();
        this.passed = false;
        if (button) {
          this.buttonObserver = new IntersectionObserver(([entry]) => {
            this.passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            this.updateVisibility();
          }, { threshold: 0 });
          this.buttonObserver.observe(button);
        }
      }
      this.mainQuantity = form && [...form.elements].find(input => input.name === 'quantity');
      const quantityControl = this.querySelector('.atiems-fp-sticky__qty');
      if (quantityControl) quantityControl.hidden = !this.mainQuantity;
      if (this.qtyInput) {
        for (const attr of ['min', 'max', 'step']) {
          const value = this.mainQuantity?.getAttribute(attr);
          if (value) this.qtyInput.setAttribute(attr, value);
          else if (attr === 'max') this.qtyInput.removeAttribute(attr);
        }
        if (this.mainQuantity) this.qtyInput.value = this.mainQuantity.value;
      }
      if (this.addButton) {
        this.addButton.disabled = !button || button.disabled || button.getAttribute('aria-busy') === 'true';
        const label = button?.textContent.replace(/\s+/g, ' ').trim();
        const next = label || this.addLabel;
        if (this.addButton.textContent !== next) this.addButton.textContent = next;
      }
      const mainPrice = document.querySelector('.shopify-section--main-product sale-price');
      if (this.price && mainPrice) this.price.textContent = mainPrice.textContent.replace(/\s+/g, ' ').trim();
      this.updateVisibility();
    }
    updateVisibility() {
      const dialogOpen = Boolean(document.querySelector('cart-drawer[open], header-sidebar[open], quick-buy-modal[open], x-modal[open]'));
      const privacyOpen = [...document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner__dialog')]
        .some(element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
      const show = Boolean(this.mainButton && this.passed && !dialogOpen && !privacyOpen);
      this.hidden = !show;
      document.documentElement.classList.toggle('atiems-fp-sticky-on', show);
    }
    submit() {
      if (!this.form || !this.mainButton || this.mainButton.disabled) return;
      if (this.qtyInput && !this.qtyInput.reportValidity()) return;
      if (this.mainQuantity && this.qtyInput) {
        this.mainQuantity.value = this.qtyInput.value;
        this.mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.form.requestSubmit(this.mainButton);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('variant:change', this.onVariant);
      document.removeEventListener('dialog:after-show', this.onState);
      document.removeEventListener('dialog:after-hide', this.onState);
      document.removeEventListener('change', this.onQuantity);
      window.removeEventListener('resize', this.onResize);
      this.buttonObserver?.disconnect();
      this.mainObserver?.disconnect();
      this.drawerObserver?.disconnect();
      document.documentElement.classList.remove('atiems-fp-sticky-on');
    }
  });
}
